import { useSearchParams } from "react-router-dom";
import { useOrder } from "../../../entities/order";
import { isMobile } from "../../../shared/lib/device";
import { LoadingView, PaymentStatusView } from "../../../shared/ui";
import { LayoutMain } from "../../../widgets/layout-main";
import { FakedoorDesktop } from "./fakedoor-desktop";
import { FakedoorMobile } from "./fakedoor-mobile";

export const FakedoorPage = () => {
  const [searchParams] = useSearchParams();
  const onlineOrderId = searchParams.get("onlineOrderId") ?? undefined;

  const { data, isLoading } = useOrder({
    onlineOrderId,
  });

  if (isLoading)
    return (
      <LayoutMain>
        <LoadingView />
      </LayoutMain>
    );

  if (!data || data.online_order_status === "REFUNDED")
    return (
      <LayoutMain>
        <PaymentStatusView status="UNAVAILABLE" />
      </LayoutMain>
    );

  const { link, link_qr } = data;

  return (
    <LayoutMain>
      {isMobile ? (
        <FakedoorMobile link={link as string} />
      ) : (
        <FakedoorDesktop linkQr={link_qr as string} />
      )}
    </LayoutMain>
  );
};
